export function SendSundayRunEmailInit() {
    // Use JS to update these values since Blazor won't see these dynmically rendered HTML elements

    // In email preview, inject/remove "Is Private" message
    document.getElementById("IsPrivate")?.addEventListener("change", () => WriteEmailPublicPrivateRunMessage());

    // In email preview,  inject/remove special message content
    document.getElementById('divEditableContent')?.addEventListener('input', () => WriteEmailSpecialNoteIntoEmailPreview());
    document.getElementById('divEditableContent')?.addEventListener('paste', () => WriteEmailSpecialNoteIntoEmailPreview());
}

function WriteEmailPublicPrivateRunMessage() {
    let Msg = "The BTC Sunday Long Run is open to everyone, members and non-members.";
    if ((document.getElementById('IsPrivate') as HTMLInputElement).checked) // Is private this week?
        Msg = "<strong>Note:</strong> This week's BTC Sunday Long Run is private, for BTC members only.";

    // Note: The "PublicPrivateMsg" span element comes from the server when the preview section is rendered
    const elMsg: HTMLSpanElement = (document.getElementById('PublicPrivateMsg') as HTMLSpanElement);
    if (elMsg !== null) // Could be null if, for eg, an unknown SundayRunId was sent to server.
        elMsg.innerHTML = Msg;
}

function WriteEmailSpecialNoteIntoEmailPreview() {
    const divSpecialNoteHtml = document.getElementById('divEditableContent') as HTMLDivElement;
    const pEmailSpecialMessage = document.getElementById("pEmailSpecialMessage") as HTMLParagraphElement;
    if (pEmailSpecialMessage) {
        const spanEmailSpecialMessage = document.getElementById('spanEmailSpecialMessage') as HTMLSpanElement;
        // Check for standalone <br> since some browsers will embed it (eg Firefox, Chrome)
        if (divSpecialNoteHtml.innerText.trim() === "" || divSpecialNoteHtml.innerHTML === "<br>") {
            pEmailSpecialMessage.style.display = "none";
            spanEmailSpecialMessage.innerHTML = "";
        }
        else {
            pEmailSpecialMessage.style.display = "revert";
            spanEmailSpecialMessage.innerHTML = divSpecialNoteHtml.innerHTML;
        }
    }
}

export function WriteEmailBodyToDiv(Body: string): void {
    document.getElementById('divEmailBodyPreview')!.innerHTML = Body
}

export function ReadEmailBodyFromDiv(): string {
    return document.getElementById('divEmailBodyPreview')!.innerHTML;
}
